/**
 * @author Toolito <toolito@90tech.fr>
 * @copyright 2015 Zenlabs SAS. All rights reserved.
 */
;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('zlUserCard', UserCardDirective)

  UserCardController.$inject = ['UserManager', 'ColorService']

  function UserCardController (UserManager, ColorService) {
    var self = this

    var isShown = false
    self.$onInit = () => {
      _.extend(self, {
        colorService: ColorService,
        isShown: isShown,

        showCard: showCard,
        hideCard: hideCard

      })
    }

    self.style = function () {
      switch (self.position) {
        case 'right':
          return { left: '0' }
        case 'left':
          return { right: '0' }
        default:
          return { left: '-170px' }
      }
    }

    function showCard () {
      if (typeof self.technician === 'string') {
        self.loading = true
        UserManager.getById(self.technician, { 'ignoreErrors': [404] }).then(function (tech) {
          self.technician = tech
          self.loading = false
        }, function () {
          self.unknown = true
          self.loading = false
        })
      }
      self.isShown = true
    }

    function hideCard () {
      self.isShown = false
    }
  }

  UserCardDirective.$inject = []

  /**
   * Common directive used to popup a user card on event
   * @type Directive
   * @returns {{restrict: string, templateUrl: string, controller: UserCardController, controllerAs: string, link: link, scope: {user: string, event: string}}}
   * @constructor
   */
  function UserCardDirective () {
    return {
      restrict: 'A',
      templateUrl: '/app/common/directives/user-card/user-card.html',
      controller: UserCardController,
      controllerAs: 'uCard',
      transclude: true,
      replace: false,
      scope: {},
      bindToController: {
        position: '@',
        technician: '=zlUserCard'
      }
    }
  }
})(window.angular, window._)
